import PropTypes from 'prop-types';
import React from 'react';
import qs from 'qs';
import { withRouter } from 'react-router';
import { withExperimentsState } from './../../hocs';

import ExperimentRow from './ExperimentRow';

import { experimentsContainer } from './styles.module.css';

class ExperimentSwitcher extends React.PureComponent {
  updateExperiment = (expName, expValue) => {
    if (__SERVER__) {
      return;
    }
    const { query, pathname } = this.props.location;
    query.exp_enable = `${expName}:${expValue}`;
    window.location.href = `${pathname}?${qs.stringify(query)}`;
  };
  render() {
    const experimentStates = Object.entries(this.props.experimentState).map(
      ([expName, expValue]) => {
        return (
          <ExperimentRow
            updateExperiment={this.updateExperiment}
            key={expName}
            name={expName}
            value={expValue}
          />
        );
      },
    );

    return (
      <div className={experimentsContainer}>
        <ul>{experimentStates}</ul>
      </div>
    );
  }
}

ExperimentSwitcher.propTypes = {
  experimentState: PropTypes.shape().isRequired,
};

export default withRouter(withExperimentsState(ExperimentSwitcher));
